import AppRouter from "./AppRouter";
import "./styles/App.scss";
import MessengerCustomerChat from "react-messenger-customer-chat";

const App = () => {
  return (
    <>
      <AppRouter></AppRouter>
      <MessengerCustomerChat
        pageId="2501113563238833"
        appId="168490052104646"
      />
    </>
  );
};

export default App;
